import React from "react";
import { logout } from "../hooks/Utility";

const divStyle = {

  backgroundColor: '#319ee7',
  padding : '10px 40px 10px 40px' ,
  borderRadius: '2px',
  color:'white'
  

  
  
  
};

function Commonheader(props) {
  return (
    <div>
      <div className="header-holder d-flex align-items-center justify-content-between my-2">
        <div className="back-button">
          <button
            type="button"
            className="btn btn-outline-primary rounded-circle"
            onClick={() => props.props.history.goBack()}
          >
            <i className="fa fa-chevron-left"></i>
          </button>
        </div>
        <div className="title-holder" style={divStyle}>{props.pagetitle}</div>
        <div className="logout-button">
          <button
            type="button"
            onClick={logout}
            className="btn btn-outline-primary rounded-circle"
          >
            <i className="fa fa-power-off"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Commonheader;
